import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import CircleCheckMarkIcon from '@icons/CircleCheckMarkIcon';
import CircleDangerIcon from '@icons/CircleDangerIcon';
import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import { ButtonPrimaryLarge } from '@styled';

const SubmitButton = ({
    children,
    onClick,
    buttonClasses = '',
    style = {},
    isDisabled = false,
    isSubmitting = false,
    isSuccessful = false,
    isError = false,
    submittingText = 'Saving...',
    errorText = 'Error saving.',
    successText = 'Success!',
}) => {
    const handleOnClick = e => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    const classes = classnames(
        'mt-4',
        'mb-1',
        'd-flex',
        'align-items-center',
        'justify-content-center',
        buttonClasses,
        { isSubmitting, isSuccessful, isError }
    );

    return (
        <ButtonPrimaryLarge
            type="submit"
            onClick={handleOnClick}
            className={classes}
            style={{ ...style, zIndex: isSubmitting ? '2' : 'auto' }}
            disabled={isSubmitting || isSuccessful || isError || isDisabled}
        >
            <span className="fade-in-fast d-flex align-items-center justify-content-center">
                {isSubmitting && (
                    <>
                        <LoadingSpinnerIcon fill="#545454" style={{ marginRight: '10px' }} />
                        {submittingText}
                    </>
                )}

                {isSuccessful && (
                    <>
                        <CircleCheckMarkIcon />
                        {successText}
                    </>
                )}

                {isError && (
                    <>
                        <CircleDangerIcon />
                        {errorText}
                    </>
                )}
            </span>

            {!isSubmitting && !isSuccessful && !isError && children}
        </ButtonPrimaryLarge>
    );
};

SubmitButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onClick: PropTypes.func,
    buttonClasses: PropTypes.string,
    isDisabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isSuccessful: PropTypes.bool,
    isError: PropTypes.bool,
    style: PropTypes.object,
    submittingText: PropTypes.string,
    errorText: PropTypes.string,
    successText: PropTypes.string,
};

export default SubmitButton;
